import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, FormControl, FormControlLabel, Checkbox, Box, Typography, TextField, Button, Grid, Alert } from "@mui/material";
import { partnersAPI } from '../../Api';

const PartnersAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    basic: false,
    FunPay: { cookies: "" },
    Yandex: { apiKey: "", clientId: "", companyId: "" },
    proxy: { ip: "", port: "", login: "", password: "" },
  });
  const fieldsList = [
    { key: "name", label: "Название" },
    { key: "basic", label: "Основной магазин" },
    { key: "FunPay.cookies", label: "Куки Фанпей" },
    { key: "Yandex.apiKey", label: "API ключ Яндекс.Маркет" },
    { key: "Yandex.clientId", label: "Client ID Яндекс.Маркет" },
    { key: "Yandex.companyId", label: "Company ID Яндекс.Маркет" },
    { key: "proxy.ip", label: "IP прокси" },
    { key: "proxy.port", label: "Порт прокси" },
    { key: "proxy.login", label: "Логин прокси" },
    { key: "proxy.password", label: "Пароль прокси" },
  ];

  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);

  const transformFormDataToSchema = (formData) => {
    return {
      name: formData.name,
      basic: formData.basic,
      FunPay: formData.FunPay,
      Yandex: formData.Yandex,
      proxy: formData.proxy,
    };
  };

  const flattenFormData = (data) => {
    let result = {};
    for (const key in data) {
      const value = data[key];
      if (typeof value === "object" && value !== null) {
        Object.assign(result, flattenFormData(value, key));
      } else {
        result[key] = value;
      }
    }
    return result;
  };

  const unflattenFormData = (data) => {
    let result = { FunPay: {}, Yandex: {}, proxy: {} };
    for (const key in data) {
      const value = data[key];
      const keys = key.split(".");
      if (keys.length === 1) {
        result[key] = value;
      } else if (keys.length === 2) {
        result[keys[0]][keys[1]] = value;
      }
    }
    return result;
  };

  useEffect(() => {
    if (id) {
      const fetchPartners = async () => {
        try {
          const { data } = await partnersAPI.getPartnersById(id);
          setFormData(unflattenFormData(data.data)); // Преобразуем данные перед установкой
        } catch (error) {
          console.log(error);
        }
      };
      fetchPartners();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const keys = name.split(".");

    setFormData((prev) => {
      if (keys.length === 1) {
        return {
          ...prev,
          [name]: type === "checkbox" ? checked : value,
        };
      } else {
        const [parent, child] = keys;
        return {
          ...prev,
          [parent]: {
            ...prev[parent],
            [child]: type === "checkbox" ? checked : value,
          },
        };
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      let text = "";
      let response = null;
      if (id) {
        response = await partnersAPI.updatePartner(id, transformFormDataToSchema(formData));
        text = "Партнер успешно обновлен!";
      } else {
        response = await partnersAPI.createPartner(transformFormDataToSchema(formData));
        text = "Партнер успешно добавлен!";
      }

      if (response.data?.success) {
        setAlert(<Alert severity="success">{text}</Alert>);
        setTimeout(() => {
          navigate("/partners/list");
        }, 1000);
      } else {

        setAlert(<Alert severity="error">{response.data.data.error}</Alert>);
      }
    } else {
      setAlert(<Alert severity="error">Название обязательны к заполнению</Alert>);
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = "";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2, bgcolor: "#fff" }}>
        <Typography variant="h5" align="center" gutterBottom>
          {id ? "Редактирование партнера" : "Добавление партнера"}
        </Typography>
        {alert && <Box sx={{ mb: 2 }}>{alert}</Box>}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ mb: 3, mt: 3 }} alignItems="center">
            {fieldsList.map(({ key, label }) => {
              const keys = key.split(".");
              let fieldValue = formData[keys[0]];
              if (keys.length > 1) {
                fieldValue = fieldValue[keys[1]]; // Если есть второй ключ, получаем вложенное значение
              }

              return (
                <Grid item xs={12} sm={6} key={key}>
                  {key === "basic" ? (
                    <FormControl>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={fieldValue}
                            onChange={handleChange}
                            name={key}
                          />
                        }
                        label={label}
                      />
                    </FormControl>
                  ) : (
                    <TextField
                      label={label}
                      variant="outlined"
                      size="small"
                      fullWidth
                      name={key}
                      value={fieldValue || ""}
                      onChange={handleChange}
                      error={Boolean(errors[key])}
                      helperText={errors[key] || ""}
                      sx={{
                        height: 40,
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6a1b9a", // Цвет обводки при фокусе
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#6a1b9a", // Цвет метки при фокусе
                        },
                      }}
                    />
                  )}
                </Grid>
              );
            })}
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              sx={{ width: "200px", backgroundColor: "#6a1b9a" }}
            >
              {id ? "Сохранить" : "Добавить"}
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default PartnersAdd;
